import { BookedMeetingCalendarEventAttendeeI } from "shared/lib/interfaces/meeting-acceptance";
import { getInitialsFromUsername } from "shared/lib/helpers";
import {
  AccountDetailsStatusI,
  AccountDispositionStatusI,
} from "shared/lib/interfaces/account";
import { ACCOUNT_DISPOSITION_STATUSES } from "shared/lib/constants/account";

export const getFallbackTextForBookedMeetingEventAttendeeAvatar = (
  attendee: BookedMeetingCalendarEventAttendeeI
) => {
  if (attendee.name) {
    return getInitialsFromUsername(attendee.name);
  } else if (attendee.email) {
    const username = attendee.email.split("@")[0];

    if (username.indexOf(".") >= 0) {
      return getInitialsFromUsername(username.split(".").join(" "));
    }

    return username.slice(0, Math.min(2, username.length));
  }

  return "n/a";
};

/**
 * GLE-8249: the lead the move endpoint is addressed to. `meeting_contact_ids`
 * lists the leads with a live upcoming meeting (GLE-8230) and is the source
 * of truth; the primary contact is only the legacy fallback the Modify flow
 * also uses. With several live meetings the first one is taken, which is the
 * one the card shows.
 */
export const getMeetingContactId = (
  accountStatus: AccountDetailsStatusI | undefined
): string | undefined => {
  if (!accountStatus) {
    return undefined;
  }

  return (
    accountStatus.meeting_contact_ids?.[0] ||
    accountStatus.primary_contact_id ||
    undefined
  );
};

export const checkIfAccountShouldShowCalendarEventStatus = (
  accountStatus: AccountDetailsStatusI | undefined
) => {
  if (!accountStatus) {
    return false;
  }

  return (
    (
      [
        ACCOUNT_DISPOSITION_STATUSES.MEETING_SCHEDULED,
        ACCOUNT_DISPOSITION_STATUSES.NURTURE,
      ] as AccountDispositionStatusI[]
    ).includes(accountStatus.status as AccountDispositionStatusI) &&
    accountStatus.may_have_calendar_event
  );
};
